import React from 'react'
import { useSelector } from 'react-redux'

import styles from '../../ProductsDocs.module.scss'

import InputGroup from 'components/elements/forms/InputGroup'
import CustomInput from 'components/elements/inputs/CustomInput'
import CopyButton from 'components/elements/buttons/CopyButton'
import { BookOpen as BookIcon } from '../../../../icons'
import UnblockerManualBlock from '../UnblockerManualBlock'

import { selectScrapperApiKey } from 'store/user/selectors'

const UnblockerDocs: React.FC = () => {
  const scrapperApiKey = useSelector(selectScrapperApiKey)

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerIconWrapper}>
          <BookIcon />
        </div>
        <h3 className={styles.title}>Web Data API documentation</h3>
      </div>

      <div className={styles.content}>
        <InputGroup className={styles.inputGroup} labelTop={'Your API key'}>
          <CustomInput
            className={styles.keyInput}
            placeholder={'Key'}
            value={scrapperApiKey}
            readOnly
            // onChange={}
          />

          <CopyButton
            className={styles.copy}
            text={scrapperApiKey}
            color={'blue'}
          />

          {/*<CustomButton color={'outline'}>Generate new</CustomButton>*/}
        </InputGroup>

        <UnblockerManualBlock />
      </div>
    </div>
  )
}

export default UnblockerDocs
